import React, { FC } from 'react'
import TransactionsContainer from 'containers/Transactions'

const TransactionPage: FC = () => <TransactionsContainer />

export default TransactionPage
